import { Icon, Box, BoxTitle, Indication,InlineLeft,InlineRight } from './styles';
import InputField from "../../../components/InputField";
import ActionBar from "../../../components/ActionBar";
import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/types';
import { serviceLoading } from 'common/loaderReducer';
import { SEARCHING_BY_LABEL_API_REQUEST } from 'features/Dealers/ConnectByLabel/state/actionTypes';
import { searchByLabelAPI } from './state/actions';

const FindListingsBox = () => {
    const [businessAccountLabel, setbusinessAccountLabel] = React.useState("");
    const dispatch = useDispatch();

    const rootProps = useSelector((rootState: RootState) => {
        const isSearchingByLabel = serviceLoading(rootState, [SEARCHING_BY_LABEL_API_REQUEST]);
        return {
            dealerId: rootState.dealers.dealer.selectedDealer?.id,
            isSearchingByLabel
        }
    }, shallowEqual);

    return (
        <Box>
            <BoxTitle>
                Connect your account with Google Business Profile to get started
            </BoxTitle>
            <Indication>
                Please enter the name for your dealership
            </Indication>
            <InlineLeft>
                <InputField
                    label={"Dealer Location Name"}
                    value={businessAccountLabel}
                    onChange={setbusinessAccountLabel}
                    placeholder={""}
                />
            </InlineLeft>
            <InlineRight>
                <ActionBar
                    mainActionLabel={"SEARCH"}
                    secondaryActionLabel={"CANCEL"}
                    onMainActionClick={() => dispatch(searchByLabelAPI(rootProps.dealerId?rootProps.dealerId:'', businessAccountLabel))}
                    onSecondaryActionClick={() => { setbusinessAccountLabel("") }}
                    mainActionDisabled={businessAccountLabel == "" ? true : false}
                    mainActionLoading={rootProps.isSearchingByLabel ? true : false}
                />
            </InlineRight>
        </Box>
    )
}

export default FindListingsBox